var TextArea = require('./textArea');


module.exports = TextArea.extend({

    initialize: function() {

        this.pageLevelLineIds = [];
        this.pageLevelWordIds = [];

        this.docLevelLineIds = [];
        this.docLevelWordIds = [];

        TextArea.prototype.initialize.apply( this, arguments );
    },

    addPageLevelLineId: function( pageLevelLineId ) {

        this.pageLevelLineIds.push( pageLevelLineId );

    },


    addPageLevelWordId: function( pageLevelWordId ) {

        this.pageLevelWordIds.push( pageLevelWordId );

    },

    /* Don't add dupes */
    addDocLevelLineId: function( docLevelLineId ) {

        if ( this.docLevelLineIds.indexOf( docLevelLineId ) < 0 )
            this.docLevelLineIds.push( docLevelLineId );

    },

    addDocLevelWordId: function( docLevelWordId ) {

        this.docLevelWordIds.push( docLevelWordId );

    },

    getPageLevelLineIds: function() {
        return this.pageLevelLineIds;
    },

    getPageLevelWordsIds: function() {
        return this.pageLevelWordIds;
    },

    getDocLevelLineIds: function() {

        return this.docLevelLineIds;

    },

    getDocLevelWordIds: function() {

        return this.docLevelWordIds;

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/positionalTextModels/textAreaModels/zone.js
 ** module id = 348
 ** module chunks = 0
 **/